import { Controller } from "@hotwired/stimulus"

// Affiche les champs et le bloc « Relais disponible » seulement quand
// l'interrupteur « Prêt relais » est activé (issue #746). Les inputs restent
// sérialisés : le relais vaut 0 côté serveur quand l'interrupteur est off,
// mais les saisies doivent repartir dans le payload pour être persistées.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.refresh()
  }

  refresh() {
    const input = this.element.querySelector(
      "input[type='checkbox'][name='criterias[bridge_loan_enabled]']"
    )
    const on = !!(input && input.checked)
    this.panelTargets.forEach((panel) => {
      panel.hidden = !on
    })
  }
}
